import { fieldTypeNames } from '../constants/fields'
import { FieldTypes } from '../constants/FieldTypes'
import { DropdownField, TextField } from '../types/forms/fields'

export const placeholderField: TextField = {
  placeholder: 'Field name',
  type: FieldTypes.TEXT,
}

export const getFieldTypeField = (types: FieldTypes[]): DropdownField<FieldTypes> => ({
  type: FieldTypes.DROPDOWN,
  options: types.map(type => ({
    text: fieldTypeNames[type],
    id: type,
  })),
  placeholder: 'Field type',
})
